import React, { useState } from "react";
import { AggregatedOrderProduct, AggregatedOrderProductCombineStatus } from "./type";
import { observer } from "mobx-react-lite";
import ProductFilterTr from "./ProductFilterTr";

interface ProductFilterRowProps {
    aggregatedProduct: AggregatedOrderProduct;
    onActiveChange: (id: string, checked: boolean) => void;
    showShopName: boolean;
    showSkuProperty: boolean;
    showSkuExternalId: boolean;
    showTitle: boolean;
    onPartialSelect: (productId: string, count: number) => Promise<string | null>;
}

const ProductFilterRow: React.FC<ProductFilterRowProps> = function (props) {
    const {
        aggregatedProduct,
        onActiveChange,
        showShopName,
        showSkuProperty,
        showSkuExternalId,
        showTitle,
        onPartialSelect,
    } = props;
    const [showDetail, updateShowDetail] = useState(false);

    const isParent = aggregatedProduct.combineStatus === AggregatedOrderProductCombineStatus.PARENT;

    return (
        <>
            <ProductFilterTr
                aggregatedProduct={aggregatedProduct}
                onActiveChange={onActiveChange}
                showShopName={showShopName}
                showSkuProperty={showSkuProperty}
                showSkuExternalId={showSkuExternalId}
                showTitle={showTitle}
                showDetail={showDetail}
                onShowDetailChange={updateShowDetail}
                onPartialSelect={onPartialSelect}
            />

            {showDetail && isParent
                ? aggregatedProduct.childProducts.map((product) => {
                      return (
                          <ProductFilterTr
                              key={product.id}
                              aggregatedProduct={product}
                              onActiveChange={onActiveChange}
                              showShopName={showShopName}
                              showSkuProperty={showSkuProperty}
                              showSkuExternalId={showSkuExternalId}
                              showTitle={showTitle}
                              onPartialSelect={onPartialSelect}
                          />
                      );
                  })
                : null}
        </>
    );
};

export default observer(ProductFilterRow);
